import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import _ from "lodash";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { FormContainer } from "./styles";
import { ModalBody } from "@/common/elements/Modal/styles";
import { labels } from "@/util/label";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledUploadLinkPath,
} from "@/common/styles";
import { Button, Flex, Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { StyledDate } from "../InmateDetails/styles";
import CommonDatePicker from "@/common/elements/DatePicker";
import dayjs from "dayjs";
import FileUpload from "@/common/elements/InputElements/Upload";
import FileUploader from "../FileUploader";
import Select from "@/common/elements/InputElements/Select";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { PHOTOS_BASE_URL } from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST,
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { useSelector } from "react-redux";

export const MODE = { NEW: "new", EDIT: "edit" };

const DocsModal = forwardRef(
  (
    {
      document,
      show,
      handleCancel,
      handleSubmit,
      isLinkedDocs,
      isEdit,
      setIsEdit,
      bookingsFieldsEnabled,
      from,
    },
    ref,
  ) => {
    const [form] = Form.useForm();
    const [formData, setFormData] = useState(null);
    const [isImgUploading, setIsImgUploading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    useEffect(() => {
      if (isEdit) {
        let isShow = hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.MODIFY,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report,
        );
        if (isShow) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(false);
      }
    }, [isEdit]);
    // Expose form methods to parent
    useImperativeHandle(ref, () => ({
      submitForm: () => form.submit(),
      resetForm: () => form.resetFields(),
      getFormValues: () => form.getFieldsValue(),
      getFieldsError: () => form.getFieldsError(),
      isFieldsValidating: () => form.isFieldsValidating(),
      validateFields: () => form.validateFields(),
      form: form,
    }));

    useEffect(() => {
      setFormData(() => ({
        ...document,
        documentDate: isNonEmptyVariable(document?.documentDate)
          ? dayjs(document?.documentDate)
          : null,
      }));
    }, [document]);

    useEffect(() => {
      console.log("formData", formData);
      if (formData) {
        const updateFormData = {
          ...formData,
          description: formData?.originalData?.photos?.[0]?.description,
          fullSizePath: !isLinkedDocs
            ? formData?.originalData?.photos?.[0]?.fullSizePath
            : "",
        };

        console.log("updateFormData", updateFormData);
        form.setFieldsValue(updateFormData);
      }
    }, [formData]);

    const documentType = Form.useWatch("documentType", form);
    const fullSearch = useSelector((state) => state.fullSearch);

    const onSuccessDocsUplod = (v) => {
      form.setFieldValue("documentPath", v?.documentPath);
    };

    const getFinalPath = (path) => {
      if (path?.includes("\\")) {
        const splitPath = path.split("/");
        if (splitPath.length === 4) {
          splitPath.shift();
          splitPath.shift();
        }
        return splitPath.join("\\");
      }
      return path;
    };

    const onUpload = (e) => {
      const formData = new FormData();
      formData.append("file", e);
      formData.append("imageType", form.getFieldValue("documentType"));
      formData.append("description", form.getFieldValue("description"));

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      setIsImgUploading(true);

      api
        .post(API_ENDPOINTS?.imageUpload, formData, config)
        .then((response) => {
          const body = response?.data?.body;
          console.log(
            "body",
            PHOTOS_BASE_URL + getFinalPath(body?.fullSizePath),
          );

          form.setFieldValue("fullSizePath", body?.fullSizePath);
          form.setFieldValue("thumbnailPath", body?.thumbnailPath);
        })
        .finally(() => {
          setIsImgUploading(false);
        });
    };
    function handleFormCancel() {
      form.resetFields();
      handleCancel();
    }
    return (
      <>
        <Modal
          show={show}
          header={`${document ? "VIEW" : "ADD"} Document`}
          size="xl"
          onHide={handleFormCancel}
          designPattern="ant"
          width="70%"
          loading={isImgUploading}
          handleCancel={handleFormCancel}
          handleSubmit={handleSubmit}
          hideSubmitButton={
            from == MODULES_LIST.FACILITY_LOG ? false : isDisabled
          }
          footerCloseAction={() => setIsDisabled(false)}
          submitButtonDisabled={
            from == MODULES_LIST.FACILITY_LOG ? false : !bookingsFieldsEnabled
          }
          footerActions={[
            <Button key="SUBMIT" onClick={handleFormCancel}>
              Close
            </Button>,
            <Button key="SUBMIT" onClick={handleSubmit}>
              Submit
            </Button>,
          ]}
        >
          <ModalBody>
            <FormContainer>
              <Form form={form} initialValues={formData}>
                <StyledGridRow gutter={16}>
                  <StyledGridCol span={24} lg={24}>
                    <StyledSectionHeading marginTop="0px">
                      <span>Document Information</span>
                    </StyledSectionHeading>
                  </StyledGridCol>
                  <StyledGridCol span={8}>
                    <FormItem name="documentName" label={labels.documentName}>
                      <Select
                        placeholder="Document Name"
                        options={[
                          {
                            label: "",
                            value: "",
                          },
                          {
                            label: "Stub",
                            value: "Stub",
                          },
                        ]}
                        disabled={
                          from == MODULES_LIST.FACILITY_LOG
                            ? false
                            : !bookingsFieldsEnabled
                        }
                      />
                    </FormItem>
                  </StyledGridCol>

                  <StyledGridCol span={8}>
                    <FormItem name="documentDate" label={labels.documentDate}>
                      <CommonDatePicker
                        showTime={false}
                        placeholder="MM/DD/YYYY"
                        format="MM/DD/YYYY"
                        disabled={
                          from == MODULES_LIST.FACILITY_LOG
                            ? false
                            : !bookingsFieldsEnabled
                        }
                      />
                    </FormItem>
                  </StyledGridCol>

                  <StyledGridCol span={8}>
                    <FormItem name="author" label={labels.author}>
                      <TextField placeholder="Author" />
                    </FormItem>
                  </StyledGridCol>
                </StyledGridRow>

                <StyledGridRow>
                  <StyledGridCol span={24}>
                    <FormItem name="comments" label={labels.comments}>
                      <TextField
                        inputType="textarea"
                        placeholder="Comments"
                        rows={5}
                      />
                    </FormItem>
                  </StyledGridCol>
                </StyledGridRow>

                <StyledGridRow gutter={15}>
                  <StyledGridCol lg={24} span={24}>
                    <StyledSectionHeading>
                      <span>
                        {isLinkedDocs
                          ? "Linked Documents"
                          : "Photo Information"}
                      </span>
                    </StyledSectionHeading>
                  </StyledGridCol>
                  <StyledGridCol span={8}>
                    <FormItem
                      name="documentType"
                      label="Document Type"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: `${labels.documentType} is required`,
                      //   },
                      // ]}
                    >
                      <Select
                        options={getOptionsFromRefList("Image_Type")}
                        placeholder="Document Type"
                        disabled={
                          from == MODULES_LIST.FACILITY_LOG
                            ? false
                            : !bookingsFieldsEnabled
                        }
                      />
                    </FormItem>
                  </StyledGridCol>
                  {isLinkedDocs ? (
                    <>
                      <StyledGridCol span={15}>
                        <FormItem
                          name="documentPath"
                          label={labels.documentPath}
                        >
                          <TextField placeholder="Document Path" />
                        </FormItem>
                      </StyledGridCol>

                      <StyledGridCol span={8}>
                        <FormItem name="upload" label="Upload">
                          <FileUpload
                            payload={{ documentType: documentType }}
                            onSuccess={onSuccessDocsUplod}
                            name="docs"
                          ></FileUpload>
                        </FormItem>
                      </StyledGridCol>
                    </>
                  ) : (
                    <>
                      <StyledGridCol span={8}>
                        <FormItem
                          name="description"
                          label={labels.description}
                          required={!fullSearch}
                          rules={
                            !fullSearch
                              ? [
                                  {
                                    required: true,
                                    message: `${labels.description} is required`,
                                  },
                                ]
                              : []
                          }
                        >
                          <TextField placeholder="Description" required />
                        </FormItem>
                      </StyledGridCol>

                      <StyledGridCol span={8}>
                        <FormItem name="fullSizePath" label={labels.upload}>
                          <FileUploader
                            browseFileType="image"
                            acceptImageFormats="image/png,image/jpeg,image/jpg"
                            allowMultiple={false}
                            onUpload={onUpload}
                            imageUrlFromParent={
                              form.getFieldValue("fullSizePath")
                                ? PHOTOS_BASE_URL +
                                  getFinalPath(
                                    form.getFieldValue("fullSizePath"),
                                  )
                                : ""
                            }
                          />
                        </FormItem>
                      </StyledGridCol>
                    </>
                  )}
                </StyledGridRow>
              </Form>
            </FormContainer>
          </ModalBody>
        </Modal>
      </>
    );
  },
);

export default DocsModal;
